import { useEffect, useRef } from 'react';
import React from 'react';

import { uploadThereminvoxSound } from '../../api';
import { Skill } from '../../model/skill';
import { InnerSoundMeta, ThereminvoxTestingModeProps } from '../../model/thereminvox';

import { ThereminvoxAudio, ThereminvoxAudioUploading } from './ThereminvoxAudio';

interface ThereminvoxSoundProps extends ThereminvoxTestingModeProps {
    innerSoundMeta: InnerSoundMeta;
    setInnerSoundMeta: (meta: InnerSoundMeta) => void;
    isTestingMode?: boolean;
    skill: Skill;
    onRemove: () => void;
    position: number;
}

export const ThereminvoxSound: React.FC<ThereminvoxSoundProps> = ({
    innerSoundMeta,
    isTestingMode,
    setInnerSoundMeta,
    skill,
    onRemove,
    position,
    ...testingModeProps
}) => {
    const setInnerSoundMetaRef = useRef(setInnerSoundMeta);

    useEffect(() => {
        setInnerSoundMetaRef.current = setInnerSoundMeta;
    }, [setInnerSoundMeta]);

    const uploadSound = async () => {
        try {
            if (innerSoundMeta.state === 'uploading') {
                const outerMeta = await uploadThereminvoxSound(skill.id, innerSoundMeta.file!);

                const newInnerMeta: InnerSoundMeta = {
                    id: innerSoundMeta.id,
                    state: 'uploaded',
                    outerMeta,
                };

                setInnerSoundMetaRef.current(newInnerMeta);
            }
        } catch (_e) {
            const newInnerMeta: InnerSoundMeta = {
                id: innerSoundMeta.id,
                state: 'error',
                file: innerSoundMeta.file,
            };

            setInnerSoundMetaRef.current(newInnerMeta);
        }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => void uploadSound(), [innerSoundMeta]);

    const onErrorReload = () => {
        const newInnerMeta: InnerSoundMeta = {
            id: innerSoundMeta.id,
            state: 'uploading',
            file: innerSoundMeta.file,
        };

        setInnerSoundMetaRef.current(newInnerMeta);
    };

    switch (innerSoundMeta.state) {
        case 'uploaded':
            return (
                <ThereminvoxAudio
                    soundMeta={innerSoundMeta.outerMeta!}
                    isTestingMode={isTestingMode}
                    onRemove={onRemove}
                    position={position}
                    {...testingModeProps}
                />
            );

        case 'uploading':
            return <ThereminvoxAudioUploading soundName={innerSoundMeta.file!.name} />;

        case 'error':
            return (
                <ThereminvoxAudioUploading
                    onErrorReload={onErrorReload}
                    soundName={innerSoundMeta.file!.name}
                    onRemove={onRemove}
                />
            );
    }
};
